import { Component, OnInit, Input } from '@angular/core';

import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

import { AfiliacionService } from '../../services/afiliacion/afiliacion.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Afiliado } from '../../models/afiliado/afiliado.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';

declare const Rut: any;
declare const ageCalculator: any;

@Component({
  selector: 'app-afiliacion-tab1',
  templateUrl: '../../pages/afiliacion/afiliacion.tab1.html',
  styleUrls: ['../../pages/afiliacion/afiliacion.component.css']
})
export class AfiliacionTab1Component implements OnInit {

    rol:string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
   
    @Input() afiliado: Afiliado;
    
 
    constructor(private router:Router,  private dialog: MatDialog,
        private afiliacionService:AfiliacionService) { }

    ngOnInit(): void
    {
        let vm = this
      
    }
   

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    salir()
    {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' }  }
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed) { this.router.navigate(['/index']); }
        });
    }
}
